import { Component, OnInit } from '@angular/core';
import { NavigationEnd, RouterOutlet } from '@angular/router';
import { TopBarComponent } from '@layout/components/top-bar/top-bar.component';
import { SideBarComponent } from '@layout/components/side-bar/side-bar.component';
import { CommonComponent } from '@components/common.component';
import { filter } from 'rxjs';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [TopBarComponent, SideBarComponent, RouterOutlet],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent extends CommonComponent implements OnInit {
  async ngOnInit() {
    this.subscriptions.push(
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        window.scrollTo(0, 0);
      }),
    );
  }
}
